import { AlertInfoBase } from 'app/components/design-system-components/AlertInfoBase'
import Box from 'app/components/design-system-components/Box'
import { Button as NewButton } from 'app/components/design-system-components/Button'

interface MissingEmailAlertProps {
  onLearnMoreClick: () => void
  containerProps?: Record<string, any>
  alertProps?: Record<string, any>
}

export const MissingEmailAlert = ({
  onLearnMoreClick,
  containerProps = {},
  alertProps = {},
}: MissingEmailAlertProps) => {
  return (
    <Box {...containerProps}>
      <AlertInfoBase {...alertProps}>
        <Box>
          This application has limited functionality as the applicant is missing
          an email address.{' '}
          <NewButton onClick={onLearnMoreClick} variant="linkBlue">
            Learn more.
          </NewButton>
        </Box>
      </AlertInfoBase>
    </Box>
  )
}

export default MissingEmailAlert
